import { defineComponent as a, computed as e } from "vue";
import i from "./td-longtail-vue-components3.js";
const p = /* @__PURE__ */ a({
  __name: "arrow",
  props: {
    direction: { default: "left" },
    setPosition: { type: Boolean },
    tag: { default: "button" }
  },
  emits: { change: (t) => t },
  setup(t) {
    const o = t, n = e(() => ["button", "nuxt-link", "a"].includes(o.tag)), s = e(() => n.value ? i : o.tag);
    return { __sfc: !0, props: o, isLink: n, component: s };
  }
});
export {
  p as default
};
